import { useState, useEffect, useCallback } from "react";
import {
  AscModalAvatarChangeAvatar,
  AscModalAvatarChangePropsI,
} from "./AscModalAvatarChange.type";
import styles from "./AscModalAvatarChange.module.scss";
import AscModal from "../AscModal/AscModal";
import { CheckActiveIcon, CloseFilledRectangleIcon } from "../AscIcons";
import ChooseAvatarModalBackground from "../../assets/illustrations/choose-avatar-modal-background.svg";
import classNames from "classnames";
import {
  ChooseAvatarPersonDecor,
  ChooseAvatarPersonShadow,
} from "../AscIllustrations";
import AscButton from "../AscButton/AscButton";
import AscImage from "../AscImage/AscImage";

function AscModalAvatarChange({
  activeAvatarId,
  visible,
  setVisible,
  avatars,
  confirmButtonAction,
  confirmButtonText = "Apply changes",
  loading = false,
}: AscModalAvatarChangePropsI) {
  const [activeAvatar, setActiveAvatar] =
    useState<AscModalAvatarChangeAvatar | undefined>();

  function closeModal() {
    setVisible(false);
  }
  const handleAvatarClick = (avatar: AscModalAvatarChangeAvatar) => {
    setActiveAvatar(avatar);
  };

  const onConfirm = useCallback(
    async function onConfirm() {
      if (!activeAvatar?.id) {
        return;
      }
      await confirmButtonAction?.(activeAvatar?.id, activeAvatar);
    },
    [activeAvatar, confirmButtonAction]
  );

  useEffect(() => {
    const activeAvatar =
      avatars.find((avatar) => avatar?.id === activeAvatarId) || avatars?.[0];
    setActiveAvatar(activeAvatar);
  }, [avatars, activeAvatarId]);

  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={styles.modalClassName}
      backdropClassName={styles.backdropClassName}
      withBackground={false}
    >
      <div className={styles.element}>
        <img
          className={styles.background}
          src={ChooseAvatarModalBackground}
          alt={"background"}
        />
        <div className={styles.inner}>
          <CloseFilledRectangleIcon
            className={styles.closeIcon}
            onClick={closeModal}
            data-testid={"test-close-icon"}
          />

          <div className={styles.left}>
            <div className={styles.avatarList}>
              {avatars.map((item) => (
                <div
                  className={classNames(styles.avatarWrapper, {
                    [styles.active]: activeAvatar?.id === item.id,
                  })}
                  onClick={() => handleAvatarClick(item)}
                >
                  <AscImage
                    className={styles.avatar}
                    src={item.imageAvatarUrl}
                    alt={"avatar"}
                  />
                  {activeAvatar?.id === item.id && (
                    <CheckActiveIcon className={styles.checkIcon} />
                  )}
                </div>
              ))}
            </div>
            <AscButton
              loading={loading}
              className={styles.buttonMobile}
              onClick={onConfirm}
            >
              {confirmButtonText}
            </AscButton>
          </div>

          <div className={styles.right}>
            {activeAvatar && (
              <div className={styles.avatarPersonWrapper}>
                <div className={styles.avatarPersonInner}>
                  <AscImage
                    className={styles.avatarPerson}
                    src={activeAvatar?.imagePersonUrl}
                    alt={"avatar person"}
                  />
                  <ChooseAvatarPersonDecor
                    className={styles.avatarPersonDecor}
                  />
                  <ChooseAvatarPersonShadow
                    className={styles.avatarPersonShadow}
                  />
                </div>
              </div>
            )}

            <AscButton
              loading={loading}
              className={styles.buttonDesktop}
              onClick={onConfirm}
            >
              {confirmButtonText}
            </AscButton>
          </div>
        </div>
      </div>
    </AscModal>
  );
}

export default AscModalAvatarChange;
